import { BookmarkPage, Enum_Bookmark_Category, Resource } from '@edwin-group/cj-graphql';
import ResourceCard from '@/components/Card-v5/Resource';
import { useBookmark } from '../../hooks/useBookmark';
import { BookmarkListCard } from '../shared/BookmarkListCard';
import { buildBookmarkFilters } from '../../utils/buildBookmarkFilters';

interface ResourceCardProps {
  category: Enum_Bookmark_Category;
  type: string;
  page: BookmarkPage;
}

export default function ResourcesListCard({ category, type, page }: ResourceCardProps) {
  const filters = buildBookmarkFilters({ category, resourceType: type });
  const { data, refetch } = useBookmark<Resource>(filters);

  return (
    <BookmarkListCard
      title={type}
      data={data || []}
      page={page}
      showDivider={false}
      renderCard={(resource: Resource) => (
        <ResourceCard
          buttonText={page?.openButtonTxt || ''}
          resource={resource}
          key={resource?.slug}
          showBookmarkIcon
          onRemoveFromBookmark={refetch}
        />
      )}
    />
  );
}
